(() => {
  if (window.OCOfferPromo) return;
  window.OCOfferPromo = true;
  const format = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll('[' + key + ']', value), text || '');
  const money = value => new Intl.NumberFormat('en-PK', {style: 'currency', currency: 'PKR', minimumFractionDigits: value % 100 ? 2 : 0, maximumFractionDigits: 2}).format(value / 100);
  function render(state = window.OCStoreOffers?.state()) {
    const node = document.getElementById('oc-offer-promo-data');
    if (!node || !state) return;
    const data = JSON.parse(node.textContent), copy = data.copy;
    let message;
    if (state.hasCode) message = copy.code;
    else if (!state.nextPct) message = state.saving ? format(copy.max, {saving: money(state.saving)}) : copy.maxNoSaving;
    else if (state.nextAmount === 1 && state.nextPct === 15) message = copy.lastStep;
    else if (state.saving) message = format(copy.savedProgress, {saving: money(state.saving), amount: money(state.nextAmount), percentage: state.nextPct});
    else if (state.hasNashta) message = format(copy.companion, {amount: money(state.nextAmount), percentage: state.nextPct});
    else message = format(copy.progress, {amount: money(state.nextAmount), percentage: state.nextPct});
    document.querySelectorAll('[data-offer-announcement]').forEach(bar => {
      const status = bar.querySelector('[data-offer-bar-text]');
      if (status.textContent !== message) status.textContent = message;
      bar.querySelector('[data-offer-bar-link]').href = state.count ? data.cartUrl + '#CartRecommendationsTitle' : data.shopUrl;
      const action = bar.querySelector('[data-offer-bar-action]');
      action.textContent = (state.count ? copy.bag : copy.shop) + ' →';
      const track = bar.querySelector('[data-offer-bar-progress]');
      track.setAttribute('aria-valuenow', String(Math.round(state.progress)));
      track.setAttribute('aria-valuetext', message);
      bar.querySelector('[data-offer-bar-fill]').style.width = state.progress + '%';
      bar.dataset.eligibleSubtotal = state.total;
      bar.dataset.offerSaving = state.saving;
      bar.dataset.nextAmount = state.nextAmount;
    });
  }
  document.addEventListener('oc:prices-updated', event => render(event.detail));
  document.addEventListener('shopify:section:load', () => render());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render()); else render();
})();
